<template>
  <div>
    <el-row>
      <el-col>
        <el-button size="medium" @click="openAdd" style="margin-top:20px">上传凭证</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="3" style="margin-top:20px" v-for="(item, index) in tableData" :key="index">
        <el-card :body-style="{ padding: '0px' }" style="margin-left:10px">
          <img :src="item.FILE_URL" class="image" style="height:200px" v-if="item.FILE_TYPE === 1">
          <img :src="pdfImage" class="image" style="height:180px;width: 80%;margin-left:8%;margin-top:20px"
            v-else-if="item.FILE_TYPE === 2">
          <img :src="wordImage" class="image" style="height:180px;width: 80%;margin-left:8%;margin-top:20px"
            v-else-if="item.FILE_TYPE === 3">
          <img :src="unknowImage" class="image" style="height:180px;width: 80%;margin-left:8%;margin-top:20px" v-else>
          <div style="padding: 14px;">
            <div class="bottom clearfix">
              <el-button type="text" size="medium" class="button" @click="openImage(item.FILE_URL)" v-if="item.FILE_TYPE === 1">查看大图
              </el-button>
              <el-button type="text" size="medium" class="button" @click="downLoad(item.FILE_URL)" v-else>下载</el-button>
              <el-button type="text" size="medium" class="button" style="float:right" @click="deleteImg(item.ID)">删除</el-button>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-dialog :visible.sync="dialogVisible" :before-close="handleClose">
      <img :src="this.imgUrl" style="width:100%">
    </el-dialog>
    <el-row>
      <el-col>
        <el-dialog :visible.sync="addFormDialog" title="上传资质凭证" @close="close" width="400px" center>
          <el-form size="small" ref="addForm" v-model="addForm">
            <el-upload class="upload-demo" action="/uploadFile" ref="upload" :on-success="handleSuccess"
              :on-remove="handleRemove" :name="this.addForm.image" :multiple="false" :file-list="fileList" :limit="1">
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form>
          <div slot="footer" style="text-align: center;">
            <el-button size="small" class="operate-btn" @click="close">取消</el-button>
            <el-button size="small" class="operate-btn" @click="submitAdd">确认</el-button>
          </div>
        </el-dialog>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { queryOrderContractFun, addOrderContractFun, delOrderContractFun } from 'api/tcBanlance';

export default {
  data() {
    return {
      tableData: [],
      addFormDialog: false,
      addForm: {
        image: 'SupplierQualify',
      },
      fileList: [],
      url: '',
      dialogVisible: false,
      imgUrl: '',
      pdfImage: require('@/assets/images/pdf.png'),
      wordImage: require('@/assets/images/word.png'),
      unknowImage: require('@/assets/images/unknow.png'),
      month: sessionStorage.getItem('MONTH'),
    };
  },
  methods: {
    // ----------------------------------拉取数据
    queryContract() {
      const params = {
        ORDER_ID: Number(sessionStorage.getItem('ORDER_ID')),
      };
      queryOrderContractFun(params)
        .then((result) => {
          if (result.length !== 0) {
            this.tableData = result;
          } else {
            this.tableData = [];
            this.$message.show({ text: '暂无数据', type: 'success' });
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // ----------------------------------删除数据
    deleteImg(row) {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            FILE_ID: row,
          };
          delOrderContractFun(params).then((result) => {
            this.$message.show({ text: '删除成功', type: 'success' });
            this.queryContract();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    // ----------------------------------上传资质
    submitAdd() {
      if (document.body.style.cursor === 'wait') {
      } else if (this.url) {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            ORDER_ID: Number(sessionStorage.getItem('ORDER_ID')),
            FILE_URL: this.url,
          };
          addOrderContractFun(params).then((result) => {
            this.addFormDialog = false;
            this.url = '';
            this.$refs.upload.clearFiles();
            this.queryContract();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            this.url = '';
            this.$refs.upload.clearFiles();
            document.body.style.cursor = 'default';
          });
        } finally {}
      } else {
        this.$message.show({ text: '请选择凭证进行上传', type: 'warning' });
      }
    },
    openAdd() {
      this.addFormDialog = true;
    },
    openImage(e) {
      this.dialogVisible = true;
      this.imgUrl = e;
    },
    downLoad(e) {
      window.location.href = e;
    },
    handleSuccess(response, file, fileList) {
      this.url = response.base_url + response.file_name;
    },
    handleRemove(file, fileList) {
      this.url = '';
    },
    close() {
      this.addFormDialog = false;
    },
    handleClose() {
      this.dialogVisible = false;
    },
  },
  created() {
    this.queryContract();
  },
};
</script>
<style>
.image {
  width: 100%
}
</style>



// WEBPACK FOOTER //
// src/components/financeCenter/settlementOrderContract.vue